import React, { useEffect, useState } from "react";
import ContactModal from "./ContactModal";
import { Loader2, Pencil, Trash2, Filter, X, Plus, ChevronDown, Search } from "lucide-react";
import { useAPI } from "../Context/MyContext";
import toast from "react-hot-toast";
import FilterComponent from "../Component/contacts/FilterComponent";
import { debounce } from "lodash";
import { useCallback } from "react";

const Contact = () => {
  const [contacts, setContacts] = useState([]);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [totalPage, setTotalPage] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [deleteId, setDeleteId] = useState(null);
  const [attributes, setAttributes] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [editContact, setEditContact] = useState(null);
  const [activeFilters, setActiveFilters] = useState({});
  const [selectedContacts, setSelectedContacts] = useState([]);
  const hasSelection = selectedContacts.length > 0;
  const isSingleSelection = selectedContacts.length === 1;
  const [isActionsOpen, setIsActionsOpen] = useState(false);
  const [isManageTagOpen, setIsManageTagOpen] = useState(false);
  const [selectedTag, setSelectedTag] = useState("");

  const [isBlockOptOpen, setIsBlockOptOpen] = useState(false);
  const [incomingAction, setIncomingAction] = useState("NONE");
  const [optedIn, setOptedIn] = useState("NONE");
  const [tagStep, setTagStep] = useState("initial");
  const [showDropdown, setShowDropdown] = useState(false);
  // const [tagPairs, setTagPairs] = useState([]);


  const [tagPairs, setTagPairs] = useState([{ key: "", value: "" }]);
  const [tagAction, setTagAction] = useState("add");

  const [availableTags, setAvailableTags] = useState([]);
  const [isBroadcastOpen, setIsBroadcastOpen] = useState(false);
  const [allowBroadcast, setAllowBroadcast] = useState(true);

  const { getContacts, deleteContact, getAttributes, updateBulkContacts, updateAllowBroadcast } = useAPI();
  const user = JSON.parse(localStorage.getItem("user"));
  const actionsRef = React.useRef(null);


  // console.log("activeFilters are :", activeFilters)

  // Fetch Attributes
  useEffect(() => {
    const fetchAttributes = async () => {
      try {
        const res = await getAttributes();
        if (res && Array.isArray(res.attributes)) {
          setAttributes(res.attributes);
        } else {
          setAttributes([]);
        }
      } catch (err) {
        console.error("Failed to fetch attributes:", err);
        setAttributes([]);
      }
    };

    fetchAttributes();
  }, []);

  // Fetch Contacts
  const fetchContacts = async () => {
    try {
      setLoading(true);

      // Convert activeFilters object into array
      const filtersArray = Object.values(activeFilters).filter(Boolean); // get only values

      // const params = { search, page, limit: itemsPerPage, ...activeFilters };
      const params = {
        search,
        page,
        limit: itemsPerPage,
        filters: filtersArray
      };

      const res = await getContacts(params);
      setContacts(res.data || []);
      setTotal(res.totalContacts || 0);
      setTotalPage(res.totalPages || 1);
    } catch (err) {
      console.error("Failed to fetch contacts:", err);
      toast.error("Failed to fetch contacts.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContacts();
  }, [search, page, itemsPerPage, activeFilters]);

  const handleDeleteConfirm = async () => {
    try {
      await deleteContact(deleteId);
      toast.success("Contact deleted.");
      setDeleteId(null);
      fetchContacts();
    } catch {
      toast.error("Failed to delete contact.");
    }
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setPage(1);
    setSearch(searchInput.trim().toLowerCase());
  };




  const handleFilterApply = (filters) => {
    setActiveFilters(filters); // keep operator & value intact
    setPage(1);
  };


  const handleSearch = useCallback(
    debounce((query) => {
      setSearch(query.trim().toLowerCase());
    }, 500),
    []
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (actionsRef.current && !actionsRef.current.contains(event.target)) {
        setIsActionsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);



  const handleBroadModel = () => {
    if (!hasSelection) return;
    setIsActionsOpen(false);
    setIsBroadcastOpen(true);


  }
  const handleBroadCast = async () => {
    const payload = {
      contacts: selectedContacts,
      allowBroadcast: allowBroadcast,
    };

    console.log("Broadcast Payload:", payload);

    const responce = await updateAllowBroadcast(payload)

    console.log("responce::", responce)

    setIsBroadcastOpen(false);
    toast.success("Broadcast preference updated");

    // REFRESH TABLE
    fetchContacts();


  }



  const DisabledTooltip = ({ text }) => (
    <div className="absolute left-1/2 -translate-x-1/2 top-full mt-2 hidden group-hover:flex flex-col items-center z-[9999] pointer-events-none">
      <div className="w-2 h-2 bg-gray-800 rotate-45 -mb-1 z-[9999]"></div>
      <div className="bg-gray-800 text-white text-xs px-3 py-1.5 rounded-md shadow-lg whitespace-nowrap z-[9999]">
        {text}
      </div>
    </div>
  );


  const handleBulkTagUpdate = async (tagPairs, action = "add") => {
    if (!tagPairs.length || selectedContacts.length === 0) return;

    try {
      const tags = tagPairs
        .filter(p => p.key && p.value)
        .map(p => `${p.key}:${p.value}`);

      if (!tags.length) return;

      await updateBulkContacts({
        contactIds: selectedContacts,
        tags, // send array instead of single tag
        action,
      });

      toast.success(`Tags ${action}ed successfully`);
      await fetchContacts();

      setSelectedContacts([]);
      setTagStep("initial");
      setIsManageTagOpen(false);
      setTagPairs([]);
    } catch (err) {
      console.error(err);
      toast.error(err.message || `Failed to ${action} tags`);
    }
  };




  return (
    <div className="p-6 bg-[#e5ddd5] min-h-screen poppins-regular">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-3xl font-semibold text-gray-800">Contacts</h1>
      </div>

      {/* Search Bar and Action Buttons Row */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 mb-6">
        <div className="flex items-center gap-3">
          {/* Search Input - Takes most space */}
          <div className="flex-1 relative">
            <input
              type="text"
              placeholder="Search by name or number"
              value={searchInput}
              onChange={(e) => {
                setSearchInput(e.target.value);
                handleSearch(e.target.value);
              }}
              className="w-full border border-gray-300 pl-4 pr-14 py-2.5 rounded-lg 
      focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent 
      transition-all text-gray-700"
            />

            {/* Search Icon inside input */}
            <button
              onClick={handleSearchSubmit}
              className="absolute right-2 top-1/2 -translate-y-1/2 
  bg-gray-100 text-gray-600 
  rounded-full p-2 
  cursor-default pointer-events-none"
            >
              <Search size={18} />
            </button>
          </div>


          {/* Filters Button */}
          <FilterComponent
            attributes={attributes}
            onApply={handleFilterApply}
            activeFilters={activeFilters}
          />

          {/* Actions Dropdown */}
          <div className="relative" ref={actionsRef}>
            <button
              onClick={() => setIsActionsOpen(!isActionsOpen)}
              className="flex items-center gap-2 px-5 py-2.5 border border-gray-300 rounded-lg bg-white hover:bg-gray-50 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-green-500 min-w-[120px] justify-between"
            >
              <span className="text-gray-700 font-medium">Actions</span>
              <ChevronDown
                className={`w-4 h-4 text-gray-600 transition-transform duration-200 ${isActionsOpen ? "rotate-180" : ""
                  }`}
              />
            </button>

            {isActionsOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-xl z-50 py-1">



                <div>
                  <button
                    disabled={!isSingleSelection}
                    className={`w-full text-left px-4 py-2.5 text-sm transition ${isSingleSelection
                      ? "text-gray-700 hover:bg-gray-50"
                      : "text-gray-400 bg-gray-100 cursor-not-allowed opacity-70"
                      }`}
                    onClick={() => {
                      if (!hasSelection) return;

                      // IMPORTANT PART pick first selected contact
                      const contactToEdit = contacts.find(
                        (c) => c._id === selectedContacts[0]
                      );

                      if (contactToEdit) {
                        setEditContact(contactToEdit);
                        setIsModalOpen(true);
                      }

                      setIsActionsOpen(false);
                    }}
                  >
                    Edit Contact
                  </button>

                  {!hasSelection && (
                    <DisabledTooltip text="Select at least one contact" />
                  )}
                </div>

                <div className="relative group">
                  <button
                    disabled={!hasSelection}
                    className={`w-full text-left px-4 py-2.5 text-sm transition ${hasSelection
                      ? "text-gray-700 hover:bg-gray-50"
                      : "text-gray-400 cursor-not-allowed"
                      }`}
                    onClick={() => {
                      if (!hasSelection) return;
                      setIsActionsOpen(false);
                      setIsManageTagOpen(true);
                    }}
                  >
                    Manage Tags
                  </button>
                  {!hasSelection && (
                    <DisabledTooltip text="Select at least one contact" />
                  )}
                </div>

                <div className="border-t border-gray-200 my-1" />

                <div className="relative group">
                  {/* <button
                    disabled={!hasSelection}
                    className={`w-full text-left px-4 py-2.5 text-sm transition ${hasSelection
                      ? "text-red-600 hover:bg-red-50"
                      : "text-red-300 cursor-not-allowed"
                      }`}
                    onClick={() => {
                      if (!hasSelection) return;
                      setIsActionsOpen(false);
                      setIncomingAction("NONE");
                      setOptedIn("NONE");
                      setIsBlockOptOpen(true);
                    }}

                  >
                    Block & Opt
                  </button> */}

                  <button
                    disabled={!hasSelection}
                    className={`w-full text-left px-4 py-2.5 text-sm transition ${hasSelection
                      ? "text-green-600 hover:bg-green-50"
                      : "text-gray-400 cursor-not-allowed"
                      }`}

                    onClick={handleBroadModel}
                  >
                    Broadcast
                  </button>
                  {!hasSelection && (
                    <DisabledTooltip text="Select at least one contact" />
                  )}
                </div>
              </div>
            )}
          </div>

          {/* Add Contact Button */}
          <button
            className="bg-green-500 text-white px-5 py-2.5 rounded-lg hover:bg-green-600 transition-colors font-medium flex items-center gap-2 shadow-sm hover:shadow-md"
            onClick={() => setIsModalOpen(true)}
          >
            <Plus size={18} />
            Add Contact
          </button>
        </div>
      </div>

      {/* Active Filters Display */}
      {/* {Object.keys(activeFilters).length > 0 && (
        <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
          <div className="flex flex-wrap gap-2 items-center">
            <span className="text-sm font-medium text-blue-700">
              Active Filters:
            </span>
       

            {Object.entries(activeFilters).map(([key, value]) => (
              <span key={key} className="inline-flex items-center gap-1 px-3 py-1 bg-blue-100 text-blue-800 text-sm rounded-full">
                {key}: {value.value} 
                <button
                  onClick={() => {
                    const newFilters = { ...activeFilters };
                    delete newFilters[key];
                    handleFilterApply(newFilters);
                  }}
                  className="ml-1 hover:text-blue-600"
                >
                  <X className="w-3 h-3" />
                </button>
              </span>
            ))}

          </div>
        </div>
      )} */}

      {/* Active Filters Display */}
      {
        activeFilters.length > 0 && (
          <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
            <div className="flex flex-wrap gap-2 items-center">
              <span className="text-sm font-medium text-blue-700">Active Filters:</span>

              {activeFilters.map((filter, idx) => (
                <span
                  key={`${filter.key}-${idx}`}
                  className="inline-flex items-center gap-1 px-3 py-1 bg-blue-100 text-blue-800 text-sm rounded-full"
                >
                  {filter.key}: {filter.operator} {String(filter.value)}
                  <button
                    onClick={() => {
                      const updatedFilters = [...activeFilters];
                      updatedFilters.splice(idx, 1);
                      handleFilterApply(updatedFilters);
                    }}
                    className="ml-1 hover:text-blue-600"
                  >
                    <X className="w-3 h-3" />
                  </button>
                </span>
              ))}
            </div>
          </div>
        )
      }


      {/* Table */}
      <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200">
        <table className="w-full text-sm">
          <thead
            className={`text-white transition-colors duration-200 ${selectedContacts.length > 0
              ? "bg-gray-600"
              : "bg-gradient-to-r from-green-600 to-green-500"
              }`}
          >
            {selectedContacts.length > 0 ? (
              <tr>
                <th colSpan="6" className="px-6 py-4">
                  <div className="flex items-center justify-start gap-6">
                    <div className="flex items-center gap-4">
                      <input
                        type="checkbox"
                        checked={true}
                        onChange={() => setSelectedContacts([])}
                        className="w-4 h-4 text-teal-600 rounded focus:ring-2 focus:ring-white cursor-pointer"
                      />
                      <span className="font-semibold">
                        {selectedContacts.length} contact
                        {selectedContacts.length > 1 ? "s" : ""} selected
                      </span>
                    </div>
                    <button
                      onClick={() => setSelectedContacts([])}
                      className="text-white hover:text-gray-200 font-medium text-sm"
                    >
                      Clear
                    </button>
                  </div>
                </th>
              </tr>
            ) : (
              <tr>
                <th className="px-6 py-4 text-left">
                  <input
                    type="checkbox"
                    checked={
                      contacts.length > 0 &&
                      selectedContacts.length === contacts.length
                    }
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedContacts(contacts.map((c) => c._id));
                      } else {
                        setSelectedContacts([]);
                      }
                    }}
                    className="w-4 h-4 text-green-600 rounded focus:ring-2 focus:ring-white cursor-pointer"
                  />
                </th>
                <th className="px-2 py-4 text-left font-semibold">
                  Basic Info
                </th>
                <th className="px-6 py-4 text-left font-semibold">
                  Attributes
                </th>
                <th className="px-6 py-4 text-left font-semibold">
                  Broadcast
                </th>
                <th className="px-6 py-4 text-left font-semibold">
                  Created Date
                </th>
                <th className="px-6 py-4 text-center font-semibold">
                  Actions
                </th>
              </tr>
            )}
          </thead>
          <tbody className="text-gray-700 divide-y divide-gray-100">
            {loading ? (
              Array.from({ length: 10 }).map((_, idx) => (
                <tr key={idx} className="animate-pulse">
                  <td className="px-6 py-4">
                    <div className="h-4 w-4 bg-gray-200 rounded"></div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="h-4 bg-gray-200 rounded w-32 mb-2"></div>
                    <div className="h-3 bg-gray-100 rounded w-24"></div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="space-y-2">
                      <div className="h-3 bg-gray-200 rounded w-28"></div>
                      <div className="h-3 bg-gray-100 rounded w-32"></div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="h-3 bg-gray-200 rounded w-16"></div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="h-3 bg-gray-200 rounded w-20"></div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex justify-center gap-3">
                      <div className="h-8 w-8 bg-gray-200 rounded-full"></div>
                      <div className="h-8 w-8 bg-gray-200 rounded-full"></div>
                    </div>
                  </td>
                </tr>
              ))
            ) : contacts.length ? (
              contacts.map((contact) => {
                const isSelected = selectedContacts.includes(contact._id);
                return (
                  <tr
                    key={contact._id}
                    className={`transition-colors duration-150 ${isSelected ? "bg-gray-50" : "hover:bg-gray-50"
                      }`}
                  >
                    <td className="px-6 py-4">
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedContacts([
                              ...selectedContacts,
                              contact._id,
                            ]);
                          } else {
                            setSelectedContacts(
                              selectedContacts.filter(
                                (id) => id !== contact._id
                              )
                            );
                          }
                        }}
                        className="w-4 h-4 text-teal-600 rounded focus:ring-2 focus:ring-teal-500 cursor-pointer"
                      />
                    </td>
                    <td className="px-2 py-4">
                      <div className="flex items-center gap-3">
                        <div>
                          <div className="font-semibold text-gray-900">
                            {contact.name}
                          </div>
                          <div className="text-sm text-gray-500">
                            {contact.phone}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="text-sm space-y-1">
                        {Array.isArray(contact.attribute) &&
                          contact.attribute.length > 0 ? (
                          contact.attribute.map((attr, idx) => (
                            <div
                              key={idx}
                              className="flex items-center gap-2 text-xs bg-gray-50 px-2 py-1 rounded-md"
                            >
                              <span className="font-medium text-gray-700">
                                {attr.key}:
                              </span>
                              <span className="text-gray-600">
                                {String(attr.value)}
                              </span>
                            </div>
                          ))
                        ) : (
                          <span className="inline-block bg-red-100 text-red-600 px-3 py-1 rounded-full text-xs font-medium">
                            {/* No attributes */}
                            Null
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <span
                        className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${contact.allowBroadcast === "true"
                          ? "bg-green-100 text-green-700"
                          : "bg-gray-100 text-gray-600"
                          }`}
                      >
                        {contact.allowBroadcast}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600">
                      {new Date(contact.createdAt).toLocaleDateString()}
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex justify-center gap-3">
                        <button
                          onClick={() => {
                            setEditContact(contact);
                            setIsModalOpen(true);
                          }}
                          className="p-2 rounded-full bg-blue-50 text-blue-600 hover:bg-blue-100 transition-colors duration-150"
                        >
                          <Pencil className="w-4 h-4" />
                        </button>
                        <button
                          onClick={() => setDeleteId(contact._id)}
                          className="p-2 rounded-full bg-red-50 text-red-600 hover:bg-red-100 transition-colors duration-150"
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="6" className="text-center py-12">
                  <div className="flex flex-col items-center gap-2 text-gray-400">
                    <svg
                      className="w-16 h-16"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                      />
                    </svg>
                    <p className="text-lg font-medium">No contacts found</p>
                    <p className="text-sm">
                      Try adjusting your search or filters
                    </p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex justify-between items-center mt-6 text-gray-700">
        <div className="text-sm">
          <span>
            Showing {Math.min((page - 1) * itemsPerPage + 1, total)} of {total}{" "}
            entries
          </span>
        </div>
        <div className="flex items-center gap-2">
          <button
            disabled={page === 1}
            onClick={() => setPage((p) => p - 1)}
            className="px-4 py-2 border border-gray-300 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors text-sm font-medium"
          >
            Previous
          </button>
          <span className="px-4 py-2 text-sm font-medium">
            Page {page} of {totalPage}
          </span>
          <button
            disabled={page >= totalPage}
            onClick={() => setPage((p) => p + 1)}
            className="px-4 py-2 border border-gray-300 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors text-sm font-medium"
          >
            Next
          </button>
        </div>
        <div>
          <select
            value={itemsPerPage}
            onChange={(e) => setItemsPerPage(Number(e.target.value))}
            className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </select>
        </div>
      </div>



      {/* Manage Tags Modal */}
      {
        isManageTagOpen && (
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-2xl shadow-2xl w-[600px] max-w-full max-h-[85vh] flex flex-col overflow-hidden">

              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b flex-shrink-0">
                <h2 className="text-xl font-semibold">Manage Tags</h2>
                <button
                  onClick={() => {
                    setIsManageTagOpen(false);
                    setTagPairs([{ key: "", value: "" }]);
                    setTagAction("add");
                  }}
                  className="p-2 hover:bg-gray-100 rounded-full transition"
                >
                  ✕
                </button>
              </div>

              {/* Body */}
              <div className="flex flex-col flex-1 p-6 space-y-5 overflow-hidden">

                {/* Audience */}
                <div className="bg-green-50 border border-green-200 rounded-xl p-4 text-sm flex-shrink-0">
                  <strong>{selectedContacts.length}</strong>{" "}
                  contact{selectedContacts.length > 1 && "s"} selected
                </div>

                {/* Toggle */}
                <div className="flex bg-gray-100 rounded-xl p-1 flex-shrink-0">
                  <button
                    onClick={() => setTagAction("add")}
                    className={`flex-1 py-2 rounded-lg text-sm font-medium transition ${tagAction === "add"
                      ? "bg-white shadow text-green-600"
                      : "text-gray-600"
                      }`}
                  >
                    Add
                  </button>
                  <button
                    onClick={() => setTagAction("remove")}
                    className={`flex-1 py-2 rounded-lg text-sm font-medium transition ${tagAction === "remove"
                      ? "bg-white shadow text-red-600"
                      : "text-gray-600"
                      }`}
                  >
                    Remove
                  </button>
                </div>

                {/* Scrollable Tag Inputs */}
                <div className="flex-1 overflow-y-auto overflow-x-hidden pr-2 space-y-3 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
                  {tagPairs.map((pair, idx) => (
                    <div key={idx} className="flex gap-2 items-center w-full">
                      <input
                        type="text"
                        placeholder="Key"
                        autoFocus={idx === tagPairs.length - 1}
                        value={pair.key}
                        onChange={(e) => {
                          const updated = [...tagPairs];
                          updated[idx].key = e.target.value.trim();
                          setTagPairs(updated);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            if (pair.key.trim() && pair.value.trim()) {
                              setTagPairs([...tagPairs, { key: "", value: "" }]);
                            }
                          }
                        }}
                        className="flex-1 min-w-0 border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-green-500 transition"
                      />
                      <input
                        type="text"
                        placeholder="Value"
                        value={pair.value}
                        onChange={(e) => {
                          const updated = [...tagPairs];
                          updated[idx].value = e.target.value.trim();
                          setTagPairs(updated);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            if (pair.key.trim() && pair.value.trim()) {
                              setTagPairs([...tagPairs, { key: "", value: "" }]);
                            }
                          }
                        }}
                        className="flex-1 min-w-0 border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-green-500 transition"
                      />
                      {tagPairs.length > 1 && (
                        <button
                          onClick={() =>
                            setTagPairs(tagPairs.filter((_, i) => i !== idx))
                          }
                          className="text-red-500 hover:text-red-600 text-sm px-2"
                        >
                          ✕
                        </button>
                      )}
                    </div>
                  ))}
                </div>

                {/* Add Another */}
                <button
                  onClick={() =>
                    setTagPairs([...tagPairs, { key: "", value: "" }])
                  }
                  className="text-green-600 text-sm font-medium hover:underline flex-shrink-0"
                >
                  + Add another tag
                </button>

                {/* Action Button */}
                <button
                  disabled={
                    tagPairs.some(
                      (p) => !p.key.trim() || !p.value.trim()
                    ) || new Set(tagPairs.map(p => p.key.trim())).size !== tagPairs.length
                  }
                  onClick={() => handleBulkTagUpdate(tagPairs, tagAction)}
                  className={`w-full py-3 rounded-xl text-white font-medium transition flex-shrink-0 ${tagAction === "add"
                    ? "bg-green-500 hover:bg-green-600"
                    : "bg-red-500 hover:bg-red-600"
                    } disabled:opacity-50`}
                >
                  {tagAction === "add" ? "Add Tags" : "Remove Tags"}
                </button>
              </div>
            </div>
          </div>
        )
      }







      {
        isBlockOptOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center z-50">
            <div className="bg-white rounded-xl shadow-lg w-full max-w-2xl p-6">

              {/* Header */}
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg font-semibold text-gray-800">
                  Manage Conversation Preferences
                </h2>
                <button onClick={() => setIsBlockOptOpen(false)}>
                  <X className="w-5 h-5 text-gray-500 hover:text-gray-700" />
                </button>
              </div>

              {/* Selected Contacts Box */}
              <div className="bg-green-50 border border-green-100 rounded-lg p-4 mb-6">
                <p className="text-sm text-gray-600">Contacts</p>
                <p className="font-medium text-gray-800">
                  {selectedContacts.length} contact
                  {selectedContacts.length > 1 ? "s" : ""} selected
                </p>
              </div>

              {/* Two Dropdowns Row */}
              <div className="grid grid-cols-2 gap-6 mb-6">
                {/* Incoming */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Incoming
                  </label>
                  <select
                    value={incomingAction}
                    onChange={(e) => setIncomingAction(e.target.value)}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2"
                  >
                    <option value="NONE">NONE</option>
                    <option value="BLOCK">BLOCK</option>
                    <option value="UNBLOCK">UNBLOCK</option>
                  </select>
                  <p className="text-xs text-gray-500 mt-1">
                    Make no change to incoming message behaviour.
                  </p>
                </div>

                {/* Opted In */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Opted In
                  </label>
                  <select
                    value={optedIn}
                    onChange={(e) => setOptedIn(e.target.value)}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2"
                  >
                    <option value="NONE">NONE</option>
                    <option value="YES">YES</option>
                    <option value="NO">NO</option>
                  </select>
                  <p className="text-xs text-gray-500 mt-1">
                    Make no change to Opt-in preferences.
                  </p>
                </div>
              </div>

              {/* Footer */}
              <div className="flex justify-start">
                <button
                  disabled={
                    incomingAction === "NONE" && optedIn === "NONE"
                  }
                  onClick={() => {
                    console.log({
                      contacts: selectedContacts,
                      incoming: incomingAction,
                      optedIn: optedIn,
                    });

                    setIsBlockOptOpen(false);
                    toast.success("Preferences updated");
                    // Later we can hook this to API
                  }}
                  className={`px-6 py-2.5 rounded-lg transition ${incomingAction === "NONE" && optedIn === "NONE"
                    ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                    : "bg-green-600 text-white hover:bg-green-700"
                    }`}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )
      }



      {
        isBroadcastOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center z-50">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden">

              {/* HEADER */}
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
                <div>
                  <h2 className="text-lg font-semibold text-gray-800">
                    Broadcast Preference
                  </h2>
                  <p className="text-xs text-gray-500 mt-0.5">
                    Control messaging permission for selected contacts
                  </p>
                </div>
                <button
                  onClick={() => setIsBroadcastOpen(false)}
                  className="p-2 hover:bg-gray-100 rounded-full transition"
                >
                  <X className="w-5 h-5 text-gray-500 hover:text-gray-700" />
                </button>
              </div>

              <div className="p-6 space-y-5">

                {/* SELECTED CONTACTS BOX */}
                <div className="bg-green-50 border border-green-100 rounded-lg p-4">
                  <p className="text-sm text-gray-600">Contacts</p>
                  <p className="font-medium text-gray-800">
                    {selectedContacts.length} contact
                    {selectedContacts.length > 1 ? "s" : ""} selected
                  </p>
                </div>

                {/* TOGGLE SECTION  */}
                <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                  <div className="flex items-center justify-between">
                    <div className="flex-1 pr-4">
                      <p className="font-medium text-gray-800">Allow Broadcast</p>
                      <p className="text-xs text-gray-500 mt-1">
                        Enable or disable broadcast messages for selected contacts.
                      </p>
                    </div>

                    {/* TOGGLE BUTTON */}
                    <button
                      onClick={() => {
                        const newValue = !allowBroadcast;
                        setAllowBroadcast(newValue);
                        console.log("Broadcast toggled:", newValue);
                      }}
                      className={`relative inline-flex h-6 w-12 flex-shrink-0 items-center rounded-full transition-colors duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 ${allowBroadcast
                        ? "bg-green-600 focus:ring-green-500"
                        : "bg-gray-300 focus:ring-gray-400"
                        }`}
                      role="switch"
                      aria-checked={allowBroadcast}
                    >
                      <span
                        className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-lg transition-transform duration-300 ease-in-out ${allowBroadcast ? "translate-x-6" : "translate-x-0.5"
                          }`}
                      />
                    </button>
                  </div>

                  {/* STATUS BADGE */}
                  <div className="mt-3">
                    <span
                      className={`inline-block px-3 py-1 text-xs font-medium rounded-full ${allowBroadcast
                        ? "bg-green-100 text-green-700"
                        : "bg-gray-100 text-gray-600"
                        }`}
                    >
                      {allowBroadcast ? "Broadcast Allowed" : "Broadcast Disabled"}
                    </span>
                  </div>
                </div>
              </div>

              {/* FOOTER BUTTONS */}
              <div className="flex justify-end gap-3 px-6 py-4 border-t border-gray-200 bg-gray-50">
                <button
                  onClick={() => setIsBroadcastOpen(false)}
                  className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition font-medium"
                >
                  Cancel
                </button>

                <button
                  // onClick={() => {
                  //   const payload = {
                  //     contacts: selectedContacts,
                  //     allowBroadcast: allowBroadcast,
                  //   };

                  //   console.log("Broadcast Payload:", payload);

                  //   setIsBroadcastOpen(false);
                  //   toast.success("Broadcast preference updated");

                  //   // REFRESH TABLE
                  //   fetchContacts();
                  // }}

                  onClick={handleBroadCast}

                  className="px-6 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700 transition shadow-sm font-medium"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )
      }


      {/* Modals */}
      <ContactModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setEditContact(null);
        }}
        onSuccess={fetchContacts}
        contact={editContact}
      />

      {
        deleteId && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-xl shadow-lg w-full max-w-sm">
              <h2 className="text-lg font-bold text-red-600 mb-4">
                Confirm Deletion
              </h2>
              <p className="text-gray-700 mb-4">
                Are you sure you want to delete this contact?
              </p>
              <div className="flex justify-end space-x-3">
                <button
                  className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400"
                  onClick={() => setDeleteId(null)}
                >
                  Cancel
                </button>
                <button
                  className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                  onClick={handleDeleteConfirm}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        )
      }
    </div >
  );
};

export default Contact; 
